// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"ShowMoreText_textContainer__334U2","blur":"ShowMoreText_blur__1Zk7J","text":"ShowMoreText_text__2j5QQ","button":"ShowMoreText_button__sEO-u"};